/* eslint-disable max-len */
import PropTypes from "prop-types";
import { useState } from "react";
import uuid from "react-uuid";
import "./styles.css";

export function Description({
  quota,
  stake,
  secondPlace,
  firstPlace,
  secondBetMatchType,
  matchType,
  scoreToWin,
  carryOver,
  wagerType,
  showPayout,
  payoutList,
  secondBetStake,
  onDescriptionClick,
  ballCount,
  maxScore,
}) {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isSwiping, setIsSwiping] = useState(false);

  const minSwipeDistance = 0;

  const onTouchStart = (e) => {
    setIsSwiping(true);
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientY);
  };

  const onTouchMove = (e) => {
    e.preventDefault();
    setTouchEnd(e.targetTouches[0].clientY);
  };

  const onTouchEnd = () => {
    setIsSwiping(false);
    if (!touchStart || !touchEnd) {
      return;
    }

    const distance = touchStart - touchEnd;
    const isUpSwipe = distance > minSwipeDistance;

    if (isUpSwipe) {
      onDescriptionClick();
    }
  };

  const carryOverFormat = {
    true: "Yes",
    false: "No",
  };

  const wagerTypeFormat = {
    0: "Per Hole",
    1: "Pot",
  };

  const scoreToWinFormat = {
    0: "Any Score",
    1: "Max Par",
    2: "Max Birdie",
  };

  const ballCountFormat = {
    0: "Best Ball",
    1: "Best 2 Balls",
    2: "All Balls",
    3: "Best / Worst",
  };

  const maxScoreFormat = {
    0: "Any",
    1: "Max Double",
    2: "Max Triple",
    3: "Max Quad",
  };

  const matchDescriptions = [
    {
      type: 0,
      title: "Quota",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description: `Your Quota for today is ${
        36 - +quota
      }. Your Quota is computed by subtracting your course handicap from 36 - ${quota} = ${
        36 - +quota
      }.`,
      scoringRules:
        "Double or worse = 0\nBogey = 1\nPar = 2\nBirdie = 4\nEagle = 8\nBetter than eagle = 10",
    },
    {
      type: 1,
      title: "Stroke Play (NET)",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description: `18-hole scores using your course handicap: ${quota}. Every shot counts.`,
      scoringRules: null,
    },
    {
      type: 2,
      title: "Stroke Play (Gross)",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description: "18-hole scores. Every shot counts.",
      scoringRules: null,
    },
    {
      type: 3,
      title: "Match Play",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description:
        "Classic three way Nassau - front, back and full 18.\nYou choose the press.\nSingle Foursome: 1 vs 1 and 2 vs 2\nMultiple Foursomes: Round robin team play where every team plays every other team.\nMaybe the most fun way to play group golf.",
      scoringRules: null,
    },
    {
      type: 4,
      title: "Skins (Gross)",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description:
        "Each hole is a winnable skin. If two players tie, all players tie.",
      scoringRules: null,
    },
    {
      type: 5,
      title: "Skins (Net)",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description:
        "Each hole is a winnable skin. If two players tie, all players tie.",
      scoringRules: "",
    },
    {
      type: 6,
      title: "Birdie pool (Gross)",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description:
        "Every time a player makes a birdie, every player puts $x into the pool. The last person to make a birdie in the round, wins the entire pot. Not for the timid.",
      scoringRules: "",
    },
    {
      type: 7,
      title: "Birdie pool (Net)",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description:
        "Every time a player makes a birdie, every player puts $x into the pool. The last person to make a birdie in the round, wins the entire pot. Not for the timid.",
      scoringRules: "",
    },
    {
      type: 8,
      title: "Match Play",
      stake: stake.toLocaleString("en-Us", {
        style: "currency",
        currency: "USD",
      }),
      firstPlace,
      secondPlace,
      description:
        "Classic three way Nassau - front, back and full 18.\nYou choose the press.\nSingle Foursome: 1 vs 1 and 2 vs 2\nMultiple Foursomes: Round robin team play where every team plays every other team.\nMaybe the most fun way to play group golf.",
      scoringRules: null,
    },
  ];

  const countRules = (type) => {
    if (type === 4 || type === 5) {
      return (
        <div className="header-description--description">
          <div style={{ display: "flex", flexDirection: "row" }}>
            {"Score to win: \u00A0 "}
            <div style={{ color: "white" }}>
              {scoreToWinFormat?.[scoreToWin]}
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            {"Wager Type: \u00A0 "}
            <div style={{ color: "white" }}>{wagerTypeFormat?.[wagerType]}</div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            {"Carry over: \u00A0 "}
            <div style={{ color: "white" }}>{carryOverFormat?.[carryOver]}</div>
          </div>
        </div>
      );
    }
    if (type === 1 || type === 2) {
      return (
        <div className="header-description--description">
          <div style={{ display: "flex", flexDirection: "row" }}>
            {"Gross / Net: \u00A0 "}
            <div style={{ color: "white" }}>{type === 1 ? "Net" : "Gross"}</div>
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            {"Ball Count: \u00A0 "}
            <div style={{ color: "white" }}>{ballCountFormat?.[ballCount]}</div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            {"Max Score: \u00A0 "}
            <div style={{ color: "white" }}>{maxScoreFormat?.[maxScore]}</div>
          </div>
        </div>
      );
    }
    return null;
  };

  const payouts = (type) => {
    if (type < 3) {
      return (
        <div>
          <div className="header-description--title">Payout Distribution</div>
          <div
            className="header-description--description"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {"1st Place:\u00A0 "}
            <div style={{ color: "white" }}>
              {showPayout
                ? payoutList?.[0]?.toLocaleString("en-Us", {
                    style: "currency",
                    currency: "USD",
                  })
                : `${matchDescriptions[type]?.firstPlace} %`}
            </div>
          </div>
          <div
            className="header-description--description"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {"2st Place: \u00A0"}
            <div style={{ color: "white" }}>
              {showPayout
                ? payoutList?.[1]?.toLocaleString("en-Us", {
                    style: "currency",
                    currency: "USD",
                  })
                : `${matchDescriptions[type]?.secondPlace} %`}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="header-description--title">Payout Distribution</div>
        <div
          className="header-description--description"
          style={{ display: "flex", flexDirection: "row" }}
        >
          Wanna get paid? Win some skins
        </div>
      </div>
    );
  };

  const [activeTab, setActiveTab] = useState(0);

  const titleStake = (type) => {
    if (type === 6 || type === 7) {
      return "per Hole";
    }
    if (type === 4 || type === 5) {
      return "per Hole";
    }
    return "per Player";
  };

  const renderItem = (activeMatchType) => (
    <div
      role="button"
      tabIndex="0"
      aria-hidden="true"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      style={{ overflow: isSwiping ? "hidden" : "auto" }}
    >
      <div className="header-description--title">
        {matchDescriptions[activeMatchType]?.title}
      </div>
      <div className="header-description--description">
        {matchDescriptions[activeMatchType]?.description}
      </div>
      <p className="header-description--description">
        {matchDescriptions[activeMatchType]?.scoringRules}
      </p>

      <div className="header-description--title">
        {`Stake ${titleStake(activeMatchType)}:\t ${
          activeTab === 1
            ? secondBetStake.toLocaleString("en-Us", {
                style: "currency",
                currency: "USD",
              })
            : matchDescriptions[activeMatchType]?.stake
        }`}
      </div>

      {countRules(activeMatchType)}

      {payouts(activeMatchType)}
    </div>
  );

  const tabs = [
    {
      title: "Main Bet",
    },
    { title: "Second Bet" },
  ];

  return (
    <>
      {secondBetMatchType ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            backgroundColor: "#313943",
            width: 161 * 2,
            margin: "0 auto",
            borderRadius: 7,
            marginBottom: 16,
          }}
        >
          {tabs.map((i, index) => (
            <div
              key={uuid()}
              aria-hidden="true"
              role="button"
              tabIndex="0"
              onClick={() => setActiveTab(index)}
              style={{
                width: 161,
                height: 28,
                borderRadius: 7,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: index === activeTab && "#636366",
                color: "white",
                fontFamily: "SF Pro Text",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: 13,
                lineHeight: 20,
              }}
            >
              {i.title}
            </div>
          ))}
        </div>
      ) : null}

      {renderItem(activeTab === 0 ? matchType : secondBetMatchType)}
    </>
  );
}

Description.propTypes = {
  quota: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  stake: PropTypes.number,
  firstPlace: PropTypes.number,
  secondPlace: PropTypes.number,
  matchType: PropTypes.number,
  secondBetMatchType: PropTypes.number,
  scoreToWin: PropTypes.number,
  carryOver: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  wagerType: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  payoutList: PropTypes.any,
  showPayout: PropTypes.bool,
  secondBetStake: PropTypes.number,
  onDescriptionClick: PropTypes.func.isRequired,
  ballCount: PropTypes.number,
  maxScore: PropTypes.number,
};

Description.defaultProps = {
  quota: 0,
  stake: 0,
  firstPlace: 0,
  secondPlace: 0,
  matchType: 0,
  secondBetMatchType: 0,
  scoreToWin: 0,
  carryOver: 0,
  wagerType: 0,
  payoutList: [],
  showPayout: false,
  secondBetStake: 0,
  ballCount: 0,
  maxScore: 0,
};
